export const endpoints = {
  CITY_PROBLEMS_VIEW: "/city/trouble/view",
  CITY_PROBLEMS_ATTACH: "/city/trouble/attach",
  CITY_PROBLEMS_DELETE: "/city/trouble/delete",
  CITY_ORGANIZATION_SELECT: "/city/organization/select",
}